'use client';

import { useState } from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

interface HeaderProps {
  className?: string;
}

const Header = ({ className = '' }: HeaderProps) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const navigationItems = [
    { label: 'Home', href: '/homepage' },
    { label: 'About', href: '/about' },
    { label: 'Contact', href: '/contact' },
  ];

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header className={`w-full bg-card shadow-md fixed top-0 left-0 right-0 z-50 ${className}`}>
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <Link href="/homepage" className="flex items-center space-x-2">
            <svg
              width="40"
              height="40"
              viewBox="0 0 40 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="text-primary"
            >
              <path
                d="M20 2L4 12L20 22L36 12L20 2Z"
                fill="currentColor"
                opacity="0.9"
              />
              <path
                d="M20 22L4 12V28L20 38L36 28V12L20 22Z"
                fill="var(--color-accent)"
                opacity="0.7"
              />
              <circle
                cx="20"
                cy="20"
                r="3"
                fill="var(--color-brand-gold)"
              />
            </svg>
            <span className="text-xl font-headline font-semibold text-primary">
              Pink Diamond
            </span>
          </Link>

          <nav className="hidden md:flex items-center space-x-8">
            {navigationItems.map((item) => (
              <Link
                key={item.href}
                href={item.href}
                className="text-sm font-body font-medium text-text-secondary hover:text-primary transition-colors duration-300"
              >
                {item.label}
              </Link>
            ))}
          </nav>

          <div className="hidden md:flex items-center space-x-4">
            <Link
              href="/contact"
              className="px-6 py-2.5 bg-brand-gold text-brand-gold-foreground font-cta font-semibold rounded-md hover:bg-opacity-90 transition-all duration-300 shadow-subtle"
            >
              Request Consultation
            </Link>
          </div>

          <button
            onClick={toggleMobileMenu}
            className="md:hidden p-2 text-text-secondary hover:text-primary transition-colors"
            aria-label="Toggle mobile menu"
          >
            <Icon
              name={isMobileMenuOpen ? 'XMarkIcon' : 'Bars3Icon'}
              size={24}
              variant="outline"
            />
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-card border-t border-border">
          <nav className="container mx-auto px-4 py-4 flex flex-col space-y-4">
            {navigationItems.map((item) => (
              <Link
                key={item.href}
                href={item.href}
                onClick={() => setIsMobileMenuOpen(false)}
                className="text-base font-body font-medium text-text-secondary hover:text-primary transition-colors duration-300 py-2"
              >
                {item.label}
              </Link>
            ))}
            <Link
              href="/contact"
              onClick={() => setIsMobileMenuOpen(false)}
              className="px-6 py-3 bg-brand-gold text-brand-gold-foreground font-cta font-semibold rounded-md hover:bg-opacity-90 transition-all duration-300 shadow-subtle text-center"
            >
              Request Consultation
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;